<report-grid-wrapper [header]="header" [headerTag]="'h4'" [accountId]="accountId">
	<vb-ui-data-grid [ngClass]="styles.grid" [columnDefs]="columnDefs" [rowData]="data$ | async">
	</vb-ui-data-grid>
</report-grid-wrapper>
